/**
 * @file: DepartmentAiCamera.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂ai识别摄像头规则表
 */
import request from '@/utils/request'

/**
 * 关联摄像头规则(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptaicameraDepartmentaicameraCollect(data) {
  return request({
    type: 'device',
    url: 'deptaicamera/departmentAiCamera/collect',
    method: 'post',
    data
  })
}

/**
 * 查询某规则关联的所有ai识别摄像头(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptaicameraDepartmentaicameraList(data) {
  return request({
    type: 'device',
    url: 'deptaicamera/departmentAiCamera/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DepartmentAiCamera.js